import ActionType from './actionType'
import {combineReducers} from "redux";

function slideReducer(state = {}, action) {
    switch (action.type) {
        case ActionType.SIDER_COLLAPSED:
            return Object.assign({}, state, {
                action: action
            });
        default:
            return state  // 没有匹配的action type，返回原来的state
    }
}

const initSubInfo = {
    // isSub:0,//默认的
}
function subReducer(state = initSubInfo, action) {
    const {type, data} = action
    switch (type) {
        case 'zk_sub_info':
            return {
                ...state,
                ...data,
            }
        default:
            return state;  // 没有匹配的action type，返回原来的state
    }
}

export default combineReducers({slideReducer, subReducer})